import { call, put } from 'redux-saga/effects';

import { Set } from '~commonInfra/utils/Set';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { requestFailed } from '../../../bootstrap/redux/actions/RequestFailedAction';
import { Messages } from '../../../codegen/Localize';
import { IExtractTaskInfo } from '../../../extractTask/models/IExtractTaskInfo';
import { RunExtractTasksAction } from '../../../extractTask/services/RunExtractTasksAction';
import { RunExtractRefreshAction } from '../../actions/extractRefresh/RunExtractRefreshAction';

export function* handleRunExtractRefreshAction(action: RunExtractRefreshAction) {
  try {
    yield call(executeRunExtractRefresh, action.tasks);
    yield put(requestSpaceContents());
  } catch (e) {
    yield put(requestFailed(e, Messages.unexpectedError()));
  }
}

export function executeRunExtractRefresh(items: IExtractTaskInfo[]) {
  return RunExtractTasksAction.execute(Set.fromIdItemArray(items));
}
